<template>
  <div>
    <transition name="vue-table-loader">
      <div class="vue-details-loader alt" v-if="loading">
        <span class="fa fa-cog fa-spin fa-1x"></span>
      </div>
    </transition>

    <alerts :status="alert" v-model="alert" class="categories-alerts"></alerts>

    <div class="placard mt-4 pb-3">
      <div class="row w-100 pb-0 mx-0" style="border-bottom: 1px solid #dedede">
        <ul class="nav nav-tabs">
          <li class="nav-item">
            <button
              class="nav-link rounded-0"
              :class="{ active: selectedTab === 'product' }"
              @click.stop.prevent="selectedTab = 'product'"
            >
              Product
            </button>
          </li>
          <li class="nav-item">
            <button
              class="nav-link rounded-0"
              :class="{ active: selectedTab === 'attribute' }"
              @click.stop.prevent="selectedTab = 'attribute'"
            >
              Attribute
            </button>
          </li>
          <li class="nav-item">
            <button
              class="nav-link rounded-0"
              :class="{ active: selectedTab === 'option' }"
              @click.stop.prevent="selectedTab = 'option'"
            >
              Option
            </button>
          </li>
          <li class="nav-item">
            <button
              class="nav-link rounded-0"
              :class="{ active: selectedTab === 'category' }"
              @click.stop.prevent="selectedTab = 'category'"
            >
              Category
            </button>
          </li>
          <li class="nav-item">
            <button
              class="nav-link rounded-0"
              :class="{ active: selectedTab === 'brand' }"
              @click.stop.prevent="selectedTab = 'brand'"
            >
              Brand
            </button>
          </li>
        </ul>
      </div>

      <div class="w-100 pb-0 my-3 pl-3">
        <button @click.stop.prevent="postPriorities()" class="btn btn-primary">
          Save
        </button>
      </div>

      <div v-if="selectedTab == 'product'">
        <div class="row mt-0 w-100 pb-0 col-md-12">
          <priority-select
            @prioritySelected="handlePriorities"
            :componentClass="'col-md-6'"
            :selectLabelId="'product-full'"
            :selectLabelText="'Full sync'"
            :numberPriorities="numberPriorities"
            :currentValue="priorities['product~full']"
            :priorityName="'product~full'"
          />
          <priority-select
            @prioritySelected="handlePriorities"
            :componentClass="'col-md-6'"
            :selectLabelId="'product-details'"
            :selectLabelText="'Details'"
            :numberPriorities="numberPriorities"
            :currentValue="priorities['product~details']"
            :priorityName="'product~details'"
          />
        </div>
        <div class="row mt-3 w-100 pb-0 col-md-12">
          <priority-select
            @prioritySelected="handlePriorities"
            :componentClass="'col-md-6'"
            :selectLabelId="'product-details-attributes'"
            :selectLabelText="'Details w/ product attributes'"
            :numberPriorities="numberPriorities"
            :currentValue="priorities['product~details_with_attributes']"
            :priorityName="'product~details_with_attributes'"
          />
          <priority-select
            @prioritySelected="handlePriorities"
            :componentClass="'col-md-6'"
            :selectLabelId="'product-price'"
            :selectLabelText="'Price'"
            :numberPriorities="numberPriorities"
            :currentValue="priorities['product~price']"
            :priorityName="'product~price'"
          />
        </div>
        <div class="row mt-3 w-100 pb-0 col-md-12">
          <priority-select
            @prioritySelected="handlePriorities"
            :componentClass="'col-md-6'"
            :selectLabelId="'product-inventory'"
            :selectLabelText="'Inventory'"
            :numberPriorities="numberPriorities"
            :currentValue="priorities['product~inventory']"
            :priorityName="'product~inventory'"
          />
          <priority-select
            @prioritySelected="handlePriorities"
            :componentClass="'col-md-6'"
            :selectLabelId="'product-assets'"
            :selectLabelText="'Asset'"
            :numberPriorities="numberPriorities"
            :currentValue="priorities['product~assets']"
            :priorityName="'product~assets'"
          />
        </div>
        <div class="row mt-3 w-100 pb-0 col-md-12">
          <priority-select
            @prioritySelected="handlePriorities"
            :componentClass="'col-md-6'"
            :selectLabelId="'product-attributes'"
            :selectLabelText="'Product attributes'"
            :numberPriorities="numberPriorities"
            :currentValue="priorities['product~attributes']"
            :priorityName="'product~attributes'"
          />
          <priority-select
            @prioritySelected="handlePriorities"
            :componentClass="'col-md-6'"
            :selectLabelId="'product-product_options'"
            :selectLabelText="'Product options'"
            :numberPriorities="numberPriorities"
            :currentValue="priorities['product~product_options']"
            :priorityName="'product~product_options'"
          />
        </div>
        <div class="row mt-3 w-100 pb-0 col-md-12">
          <priority-select
            @prioritySelected="handlePriorities"
            :componentClass="'col-md-6'"
            :selectLabelId="'product-create-variant'"
            :selectLabelText="'Create variant'"
            :numberPriorities="numberPriorities"
            :currentValue="priorities['product~create_variant']"
            :priorityName="'product~create_variant'"
          />
          <priority-select
            @prioritySelected="handlePriorities"
            :componentClass="'col-md-6'"
            :selectLabelId="'product-delete-variant'"
            :selectLabelText="'Delete variant'"
            :numberPriorities="numberPriorities"
            :currentValue="priorities['product~delete_variant']"
            :priorityName="'product~delete_variant'"
          />
        </div>
        <div class="row mt-3 w-100 pb-0 col-md-12">
          <priority-select
            @prioritySelected="handlePriorities"
            :componentClass="'col-md-6'"
            :selectLabelId="'product-delete'"
            :selectLabelText="'Delete'"
            :numberPriorities="numberPriorities"
            :currentValue="priorities['product~delete']"
            :priorityName="'product~delete'"
          />
          <priority-select
            @prioritySelected="handlePriorities"
            :componentClass="'col-md-6'"
            :selectLabelId="'product-reset'"
            :selectLabelText="'Reset'"
            :numberPriorities="numberPriorities"
            :currentValue="priorities['product~reset']"
            :priorityName="'product~reset'"
          />
        </div>
        <div class="row mt-3 w-100 pb-0 col-md-12">
          <priority-select
            @prioritySelected="handlePriorities"
            :componentClass="'col-md-6'"
            :selectLabelId="'product-relations'"
            :selectLabelText="'Relations'"
            :numberPriorities="numberPriorities"
            :currentValue="priorities['product~relations']"
            :priorityName="'product~relations'"
          />
        </div>
      </div>

      <div v-if="selectedTab == 'attribute'">
        <div class="row mt-0 w-100 pb-0 col-md-12">
          <priority-select
            @prioritySelected="handlePriorities"
            :componentClass="'col-md-6'"
            :selectLabelId="'attribute-create'"
            :selectLabelText="'Attribute create'"
            :numberPriorities="numberPriorities"
            :currentValue="priorities['generic_attribute~create']"
            :priorityName="'generic_attribute~create'"
          />
          <priority-select
            @prioritySelected="handlePriorities"
            :componentClass="'col-md-6'"
            :selectLabelId="'attribute-update'"
            :selectLabelText="'Attribute update'"
            :numberPriorities="numberPriorities"
            :currentValue="priorities['generic_attribute~update']"
            :priorityName="'generic_attribute~update'"
          />
        </div>
        <div class="row mt-3 w-100 pb-0 col-md-12">
          <priority-select
            @prioritySelected="handlePriorities"
            :componentClass="'col-md-6'"
            :selectLabelId="'attribute-delete'"
            :selectLabelText="'Attribute delete'"
            :numberPriorities="numberPriorities"
            :currentValue="priorities['generic_attribute~delete']"
            :priorityName="'generic_attribute~delete'"
          />
          <priority-select
            @prioritySelected="handlePriorities"
            :componentClass="'col-md-6'"
            :selectLabelId="'attribute-value-create'"
            :selectLabelText="'Attribute value create'"
            :numberPriorities="numberPriorities"
            :currentValue="priorities['generic_attribute_type_value~create']"
            :priorityName="'generic_attribute_type_value~create'"
          />
        </div>
        <div class="row mt-3 w-100 pb-0 col-md-12">
          <priority-select
            @prioritySelected="handlePriorities"
            :componentClass="'col-md-6'"
            :selectLabelId="'attribute-value-update'"
            :selectLabelText="'Attribute value update'"
            :numberPriorities="numberPriorities"
            :currentValue="priorities['generic_attribute_type_value~update']"
            :priorityName="'generic_attribute_type_value~update'"
          />
          <priority-select
            @prioritySelected="handlePriorities"
            :componentClass="'col-md-6'"
            :selectLabelId="'attribute-value-delete'"
            :selectLabelText="'Attribute value delete'"
            :numberPriorities="numberPriorities"
            :currentValue="priorities['generic_attribute_type_value~delete']"
            :priorityName="'generic_attribute_type_value~delete'"
          />
        </div>
        <div class="row mt-3 w-100 pb-0 col-md-12">
          <priority-select
            @prioritySelected="handlePriorities"
            :componentClass="'col-md-6'"
            :selectLabelId="'attribute-set-create'"
            :selectLabelText="'Attribute set create'"
            :numberPriorities="numberPriorities"
            :currentValue="priorities['generic_attribute_set~create']"
            :priorityName="'generic_attribute_set~create'"
          />
          <priority-select
            @prioritySelected="handlePriorities"
            :componentClass="'col-md-6'"
            :selectLabelId="'attribute-set-update'"
            :selectLabelText="'Attribute set update'"
            :numberPriorities="numberPriorities"
            :currentValue="priorities['generic_attribute_set~update']"
            :priorityName="'generic_attribute_set~update'"
          />
        </div>
        <div class="row mt-3 w-100 pb-0 col-md-12">
          <priority-select
            @prioritySelected="handlePriorities"
            :componentClass="'col-md-6'"
            :selectLabelId="'attribute-set-delete'"
            :selectLabelText="'Attribute set delete'"
            :numberPriorities="numberPriorities"
            :currentValue="priorities['generic_attribute_set~delete']"
            :priorityName="'generic_attribute_set~delete'"
          />
          <priority-select
            @prioritySelected="handlePriorities"
            :componentClass="'col-md-6'"
            :selectLabelId="'attribute-set-attribute-create'"
            :selectLabelText="'Attribute set w/ attributes create'"
            :numberPriorities="numberPriorities"
            :currentValue="priorities['generic_attribute_set_attribute~create']"
            :priorityName="'generic_attribute_set_attribute~create'"
          />
        </div>
        <div class="row mt-3 w-100 pb-0 col-md-12">
          <priority-select
            @prioritySelected="handlePriorities"
            :componentClass="'col-md-6'"
            :selectLabelId="'attribute-set-attribute-update'"
            :selectLabelText="'Attribute set w/ attributes update'"
            :numberPriorities="numberPriorities"
            :currentValue="priorities['generic_attribute_set_attribute~update']"
            :priorityName="'generic_attribute_set_attribute~update'"
          />
          <priority-select
            @prioritySelected="handlePriorities"
            :componentClass="'col-md-6'"
            :selectLabelId="'attribute-set-attribute-delete'"
            :selectLabelText="'Attribute set w/ attributes delete'"
            :numberPriorities="numberPriorities"
            :currentValue="priorities['generic_attribute_set_attribute~delete']"
            :priorityName="'generic_attribute_set_attribute~delete'"
          />
        </div>
      </div>

      <div v-if="selectedTab == 'option'">
        <div class="row mt-0 w-100 pb-0 col-md-12">
          <priority-select
            @prioritySelected="handlePriorities"
            :componentClass="'col-md-6'"
            :selectLabelId="'option-create'"
            :selectLabelText="'Option create'"
            :numberPriorities="numberPriorities"
            :currentValue="priorities['option~create']"
            :priorityName="'option~create'"
          />
          <priority-select
            @prioritySelected="handlePriorities"
            :componentClass="'col-md-6'"
            :selectLabelId="'option-update'"
            :selectLabelText="'Option update'"
            :numberPriorities="numberPriorities"
            :currentValue="priorities['option~update']"
            :priorityName="'option~update'"
          />
        </div>
        <div class="row mt-3 w-100 pb-0 col-md-12">
          <priority-select
            @prioritySelected="handlePriorities"
            :componentClass="'col-md-6'"
            :selectLabelId="'option-delete'"
            :selectLabelText="'Option delete'"
            :numberPriorities="numberPriorities"
            :currentValue="priorities['option~delete']"
            :priorityName="'option~delete'"
          />
          <priority-select
            @prioritySelected="handlePriorities"
            :componentClass="'col-md-6'"
            :selectLabelId="'option-value-create'"
            :selectLabelText="'Option value create'"
            :numberPriorities="numberPriorities"
            :currentValue="priorities['option_value~create']"
            :priorityName="'option_value~create'"
          />
        </div>
        <div class="row mt-3 w-100 pb-0 col-md-12">
          <priority-select
            @prioritySelected="handlePriorities"
            :componentClass="'col-md-6'"
            :selectLabelId="'option-value-update'"
            :selectLabelText="'Option value update'"
            :numberPriorities="numberPriorities"
            :currentValue="priorities['option_value~update']"
            :priorityName="'option_value~update'"
          />
          <priority-select
            @prioritySelected="handlePriorities"
            :componentClass="'col-md-6'"
            :selectLabelId="'option-value-delete'"
            :selectLabelText="'Option value delete'"
            :numberPriorities="numberPriorities"
            :currentValue="priorities['option_value~delete']"
            :priorityName="'option_value~delete'"
          />
        </div>
        <div class="row mt-3 w-100 pb-0 col-md-12">
          <priority-select
            @prioritySelected="handlePriorities"
            :componentClass="'col-md-6'"
            :selectLabelId="'option-set-create'"
            :selectLabelText="'Option set create'"
            :numberPriorities="numberPriorities"
            :currentValue="priorities['option_set~create']"
            :priorityName="'option_set~create'"
          />
          <priority-select
            @prioritySelected="handlePriorities"
            :componentClass="'col-md-6'"
            :selectLabelId="'option-set-update'"
            :selectLabelText="'Option set update'"
            :numberPriorities="numberPriorities"
            :currentValue="priorities['option_set~update']"
            :priorityName="'option_set~update'"
          />
        </div>
        <div class="row mt-3 w-100 pb-0 col-md-12">
          <priority-select
            @prioritySelected="handlePriorities"
            :componentClass="'col-md-6'"
            :selectLabelId="'option-set-delete'"
            :selectLabelText="'Option set delete'"
            :numberPriorities="numberPriorities"
            :currentValue="priorities['option_set~delete']"
            :priorityName="'option_set~delete'"
          />
          <priority-select
            @prioritySelected="handlePriorities"
            :componentClass="'col-md-6'"
            :selectLabelId="'option-set-option-create'"
            :selectLabelText="'Option set w/ options create'"
            :numberPriorities="numberPriorities"
            :currentValue="priorities['option_set_option~create']"
            :priorityName="'option_set_option~create'"
          />
        </div>
        <div class="row mt-3 w-100 pb-0 col-md-12">
          <priority-select
            @prioritySelected="handlePriorities"
            :componentClass="'col-md-6'"
            :selectLabelId="'option-set-option-update'"
            :selectLabelText="'Option set w/ options update'"
            :numberPriorities="numberPriorities"
            :currentValue="priorities['option_set_option~update']"
            :priorityName="'option_set_option~update'"
          />
          <priority-select
            @prioritySelected="handlePriorities"
            :componentClass="'col-md-6'"
            :selectLabelId="'option-set-option-delete'"
            :selectLabelText="'Option set w/ options delete'"
            :numberPriorities="numberPriorities"
            :currentValue="priorities['option_set_option~delete']"
            :priorityName="'option_set_option~delete'"
          />
        </div>
      </div>

      <div v-if="selectedTab == 'category'">
        <div class="row mt-0 w-100 pb-0 col-md-12">
          <priority-select
            @prioritySelected="handlePriorities"
            :componentClass="'col-md-6'"
            :selectLabelId="'category-create'"
            :selectLabelText="'Category create'"
            :numberPriorities="numberPriorities"
            :currentValue="priorities['category~create']"
            :priorityName="'category~create'"
          />
          <priority-select
            @prioritySelected="handlePriorities"
            :componentClass="'col-md-6'"
            :selectLabelId="'category-update'"
            :selectLabelText="'Category update'"
            :numberPriorities="numberPriorities"
            :currentValue="priorities['category~update']"
            :priorityName="'category~update'"
          />
        </div>
        <div class="row mt-3 w-100 pb-0 col-md-12">
          <priority-select
            @prioritySelected="handlePriorities"
            :componentClass="'col-md-6'"
            :selectLabelId="'category-delete'"
            :selectLabelText="'Category delete'"
            :numberPriorities="numberPriorities"
            :currentValue="priorities['category~delete']"
            :priorityName="'category~delete'"
          />
        </div>
      </div>

      <div v-if="selectedTab == 'brand'">
        <div class="row mt-0 w-100 pb-0 col-md-12">
          <priority-select
            @prioritySelected="handlePriorities"
            :componentClass="'col-md-6'"
            :selectLabelId="'brand-create'"
            :selectLabelText="'Brand create'"
            :numberPriorities="numberPriorities"
            :currentValue="priorities['brand~create']"
            :priorityName="'brand~create'"
          />
          <priority-select
            @prioritySelected="handlePriorities"
            :componentClass="'col-md-6'"
            :selectLabelId="'brand-update'"
            :selectLabelText="'Brand update'"
            :numberPriorities="numberPriorities"
            :currentValue="priorities['brand~update']"
            :priorityName="'brand~update'"
          />
        </div>
        <div class="row mt-3 w-100 pb-0 col-md-12">
          <priority-select
            @prioritySelected="handlePriorities"
            :componentClass="'col-md-6'"
            :selectLabelId="'brand-delete'"
            :selectLabelText="'Brand delete'"
            :numberPriorities="numberPriorities"
            :currentValue="priorities['brand~delete']"
            :priorityName="'brand~delete'"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProductAlerts from "../../products/product-details-alerts.vue";
import PrioritySelect from "./priorities-select.vue";
import axios from "axios";

const base_url = window.location.protocol + "//" + window.location.host;

export default {
  name: "generic-sync-v2-priorities",
  props: {
    channelId: {
      required: true,
      type: Number,
    },
  },
  components: {
    alerts: ProductAlerts,
    'priority-select': PrioritySelect,
  },
  data() {
    return {
      loading: false,
      alert: {
        message: "",
        status: "",
        timeOut: 15000,
      },
      selectedTab: "product",
      numberPriorities: 43,
      priorities: {
        "product~inventory": null,
        "product~price": null,
        "product~details": null,
        "product~assets": null,
        "product~attributes": null,
        "product~full": null,
        "product~delete": null,
        "product~reset": null,
        "product~create_variant": null,
        "product~delete_variant": null,
        "product~relations": null,
        "product~product_options": null,
        "product~details_with_attributes": null,
        "category~create": null,
        "category~update": null,
        "category~delete": null,
        "brand~create": null,
        "brand~update": null,
        "brand~delete": null,
        "generic_attribute~create": null,
        "generic_attribute~update": null,
        "generic_attribute~delete": null,
        "generic_attribute_type_value~create": null,
        "generic_attribute_type_value~update": null,
        "generic_attribute_type_value~delete": null,
        "generic_attribute_set~create": null,
        "generic_attribute_set~update": null,
        "generic_attribute_set~delete": null,
        "generic_attribute_set_attribute~create": null,
        "generic_attribute_set_attribute~update": null,
        "generic_attribute_set_attribute~delete": null,
        "option~create": null,
        "option~update": null,
        "option~delete": null,
        "option_value~create": null,
        "option_value~update": null,
        "option_value~delete": null,
        "option_set~create": null,
        "option_set~update": null,
        "option_set~delete": null,
        "option_set_option~create": null,
        "option_set_option~update": null,
        "option_set_option~delete": null,
      },
    };
  },
  mounted() {
    this.fetchPriorities();
  },
  methods: {
    fetchPriorities() {
      this.loading = true;
      axios
        .get(
          base_url + "/channels/" + this.channelId + "/sync_queue_priorities"
        )
        .then(
          function (response) {
            this.loading = false;
            if (!_.isEmpty(response.data)) {
              this.priorities = response.data;
            }
          }.bind(this)
        )
        .catch(
          function (err) {
            console.log(err);
            this.loading = false;
            this.alert.status = "alert-danger";
            this.alert.message =
              err.response.data.message ||
              "There was an error, please try again later.";
          }.bind(this)
        );
    },
    postPriorities() {
      this.loading = true;
      axios
        .post(
          base_url + "/channels/" + this.channelId + "/sync_queue_priorities",
          this.priorities
        )
        .then(
          function (response) {
            this.loading = false;
            this.$root.$emit('refresh-sync-table');
          }.bind(this)
        )
        .catch(
          function (err) {
            console.log(err);
            this.loading = false;
            this.alert.status = "alert-danger";
            this.alert.message =
              err.response.data.message ||
              "There was an error, please try again later.";
          }.bind(this)
        );
    },
    handlePriorities: function(values) {
      this.priorities[values.model] = values.value;
    }
  },
};
</script>